import { Box, Typography } from '@mui/material';

interface DashboardHeaderSectionProps {
  partnerName: string | null | undefined;
  programIconSrc: string;
}

function DashboardHeaderSection({ partnerName, programIconSrc }: DashboardHeaderSectionProps) {
  return (
    <Box
      display='flex'
      flexDirection='row'
      alignItems='center'
      justifyContent='space-between'
      mb='2rem'
      sx={{
        position: 'relative',
      }}
    >
      <Box flex={1} textAlign='center'>
        {partnerName != null && (
          <Box
            display='flex'
            justifyContent='center'
            alignContent={'center'}
            gap='16px'
            paddingTop='20px'
            px={{ xs: 2, sm: 0 }}
            flexDirection='column'
          >
            <Box
              component='img'
              src={programIconSrc}
              alt='Program Icon'
              sx={{ height: { xs: 72, sm: 90, md: 104 }, mx: 'auto' }}
            />
            <Typography
              variant='h1'
              sx={{
                fontSize: { xs: '2rem', sm: '3rem', md: '4rem' },
                lineHeight: 1.05,
                whiteSpace: 'normal',
                overflowWrap: 'anywhere',
                wordBreak: 'break-word',
              }}
            >
              {partnerName}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default DashboardHeaderSection;
